<template>
  <div>
    <Drawer
      :title="paramModalTitle"
      v-model="paramModal"
      width="550"
      :mask-closable="true"
      @on-close="paramModalCancel">
      <div>
        <Form ref="paramForm" :model="paramForm" :label-width="80" :rules="paramRule">
          <FormItem label="参数名" prop="name">
            <Input v-model="paramForm.name" clearable/>
          </FormItem>
          <FormItem label="默认值" prop="default_value">
            <Input v-model="paramForm.default_value" clearable/>
          </FormItem>
          <FormItem label="是否重启" prop="dynamic">
            <Select v-model="paramForm.dynamic" clearable>
              <Option v-for="item in isDynamic" :value="item.value" :key="item.value" :label="item.label"></Option>
            </Select>
          </FormItem>
          <FormItem label="可选范围" prop="ranges">
            <Input v-model="paramForm.ranges" clearable/>
          </FormItem>
          <FormItem label="参数描述" prop="descriptions">
            <Input type="textarea" :autosize="true" v-model="paramForm.descriptions" clearable/>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="paramModalCancel">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>
    <Card shadow>
      <Row>
        <i-col span="24" :md="18">
          <Form ref="searchForm" inline :model="searchForm">
            <FormItem prop="name">
              <i-input v-model="searchForm.name" placeholder="参数名" style="width: 200px;" class="mob-w-100"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getParams()" style="margin-left: 10px;">搜索</Button>
              <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :md="6">
          <Button style="float: right;" @click="addParam()" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加参数</Button>
        </i-col>
      </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getParams"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import {getMySQLParamList, deleteMySQLParam, pushMySQLParam} from '@/api/mysql'

export default {
  name: 'MySQLParamList',
  components: {
    Tables
  },
  data () {
    let that = this
    return {
      paramModal: false,
      paramModalTitle: '添加参数',
      isDynamic: [
        {'value': 1, 'label': '是'},
        {'value': 0, 'label': '否'}
      ],
      paramForm: {
        name: '',
        default_value: '',
        dynamic: '',
        ranges: '',
        descriptions: ''
      },
      paramRule: {
        name: [{required: true, message: 'Please enter param name', trigger: 'blur'}],
        default_value: [{required: true, message: 'Please enter param default_value', trigger: 'blur'}],
        dynamic: [{type: 'number', required: true, message: 'Please select param dynamic', trigger: 'blur'}],
        ranges: [{required: true, message: 'Please enter param ranges', trigger: 'blur'}],
        descriptions: [{required: true, message: 'Please enter param descriptions', trigger: 'blur'}]
      },
      count: 1,
      size: 15,
      page: 1,
      ordering: null,
      is_superuser: false,
      columns: [
        { title: '参数名', key: 'name', align: 'center', sortable: 'custom', minWidth: 200 },
        { title: '默认值', key: 'default_value', align: 'center', minWidth: 150 },
        {
          title: '是否重启',
          key: 'dynamic',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let dynamicChoices = {
              1: '是',
              0: '否'
            }
            return h('div', dynamicChoices[params.row.dynamic])
          },
          filters: [
            {
              label: '是',
              value: 1
            },
            {
              label: '否',
              value: 0
            }
          ],
          filterMultiple: false,
          filterRemote (value, row) {
            if (value.length > 0) {
              that.dynamic = value[0]
            } else {
              that.dynamic = ''
            }
            that.getParams()
          }
        },
        { title: '可选范围', key: 'ranges', tooltip: true, align: 'center', minWidth: 180 },
        // {title: "参数描述", key: "descriptions", align: "center"},
        {
          title: '操作',
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.handleEdit(params)
                    }
                  }
                }, [
                  h('div', '编辑')
                ]),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleDelete(params)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      marginLeft: '5px'
                    }
                  }, [
                    h('div', '删除')
                  ])
                ])

              ])
            }
          }
        }
      ],
      tableData: [],
      searchForm: {
        name: '',
        server: ''
      }
    }
  },

  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },

  methods: {
    refresh () {
      this.getParams()
    },

    getParams (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        name: this.searchForm.name,
        dynamic: this.dynamic
      }
      getMySQLParamList(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取实例列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取实例列表失败！服务器无响应'
          })
        }
      })
    },
    handleDelete (params) {
      deleteMySQLParam(params.row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getParams()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    handleSubmit () {
      this.$refs['paramForm'].validate((valid) => {
        if (valid) {
          pushMySQLParam(this.paramForm, this.paramForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getParams()
            this.paramFormReset()
            this.paramModal = false
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    changeSort (column) {
      if (column.order === 'asc') {
        this.ordering = column.key
      } else {
        this.ordering = '-' + column.key
      }

      this.getParams()
    },
    searchReset () {
      this.searchForm.name = ''
      this.dynamic = ''
    },
    addParam () {
      this.paramModal = true
    },
    paramModalCancel () {
      this.paramFormReset()
      this.paramModal = false
    },
    paramFormReset () {
      this.paramForm.name = ''
      this.paramForm.default_value = ''
      this.paramForm.dynamic = ''
      this.paramForm.ranges = ''
      this.paramForm.descriptions = ''
    },
    handleEdit (params) {
      this.paramForm.id = params.row.id
      this.paramForm.name = params.row.name
      this.paramForm.default_value = params.row.default_value
      this.paramForm.dynamic = params.row.dynamic
      this.paramForm.ranges = params.row.ranges
      this.paramForm.descriptions = params.row.descriptions
      this.paramModal = true
    }
  },
  mounted: function () {
    this.getParams()
  }
}
</script>
